import React from 'react'
import './loading.css'

const Loading = () => {
  return (
    <div className="loader-container">
      <div className="lds-hourglass loader"></div>
    </div>
  )
}

export default Loading